/**
 * /tenants/$slug/webhooks/new — route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import { CreateWebhookPage } from "@/features/webhooks/pages/create-webhook-page";

export const Route = createFileRoute("/_authed/tenants/$slug/webhooks/new")({
  component: CreateWebhookPage,
});
